import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Network } from 'relay-runtime';
import { getAggEndpoint, getRequestBody } from '@atlassian/relay-endpoint';
import { RelayExperimentalApis } from '@atlassian/relay-experimental-apis';
import { fetch as multiFetch } from '@atlassian/relay-fetch/multi-fetch';
import { createSubscribeFn } from '@atlassian/relay-subscription';
export var fetchFn = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, variables, cacheConfig) {
    var endpoint, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          endpoint = getAggEndpoint(request, cacheConfig);
          body = getRequestBody(request, variables);
          return _context.abrupt("return", fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'content-type': 'application/json',
              'X-ExperimentalApi': RelayExperimentalApis.join(',')
            },
            body: body
          }).then(function (response) {
            return response.json();
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchFn(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var network = Network.create(fetchFn);
export function createNetwork(networkOptions) {
  return Network.create(function (request, variables, cacheConfig) {
    return multiFetch(request, variables, cacheConfig, networkOptions);
  }, networkOptions.isServer === false ? createSubscribeFn(networkOptions) : undefined);
}